import {isInPage} from './functions.js';

if(isInPage(document.getElementById("customer_login"))){
    var login_page = document.getElementsByClassName("woocommerce-account");
    var login_title = document.getElementById("login_title");
    var register_title = document.getElementById("register_title");

    document.getElementById("login_title").onclick = function makeLoginPage(){
        document.getElementById("login_title").style.textDecoration = "underline";
        document.getElementById("register_title").style.textDecoration = "none";
        document.getElementById("register-form").style.display = "none";
        document.getElementById("login-form").style.display = "block";
    }

    document.getElementById("register_title").onclick = function makeRegisterPage(){
        document.getElementById("register_title").style.textDecoration = "underline";
        document.getElementById("login_title").style.textDecoration = "none";
        document.getElementById("register-form").style.display = "block";
        document.getElementById("login-form").style.display = "none";
    }
}
